import Swiper, { Lazy, Mousewheel } from 'swiper';

[...document.querySelectorAll('[data-buyers-guide-carousel]')].forEach(el => {
  // eslint-disable-next-line no-new
  new Swiper(
    `[data-buyers-guide-carousel="${el.dataset.buyersGuideCarousel}"]`,
    {
      modules: [Lazy, Mousewheel],
      freeMode: true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      watchOverflow: true,
      preloadImages: false,
      lazy: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
    }
  );
});
